import { toast } from "react-toastify";

export const toastNotify = (id: any, res: any) => {
    toast.update(id, {
        render: res.data.message,
        type: res.data.success ? "success" : "error",
        isLoading: false,
        autoClose: 3000,
    });
}